<template>
	<div :class="['avatar', variant, {'fixed-width': numberOfParticipants > 1}]" >
		<template v-if="numberOfParticipants === 1">
			<img :src="participants[0].avatar" onerror="this.src='/img/avatar.png'" class=" max-w-none tw-rounded-full" :class="[{'shadow': shadow}, {'border': border}, variant]"  />
			<div v-if="showIndicator" class="tw-rounded-full tw-w-2 tw-h-2 md:tw-w-4 md:tw-h-4  tw-absolute tw-top-0 md:tw-top-4 tw-right-0" :class="[{'tw-bg-green-500':participants[0].online === 'online'},{'tw-bg-orange-500':participants[0].online === 'recently'},{'tw-bg-gray-500':participants[0].online === 'offline'}]"></div>
		</template>
		<template v-else>
			<img v-for="(participant, i) in participants" :key="participant.id" :src="participant.avatar" :class="['tw-border-2 tw-border-white max-w-none tw-rounded-full avatar-list tw-absolute tw-top-0 tw-left-0', {'tw-ml-4' : i > 1 }]" style="" onerror="this.src='/img/avatar.png'" />
		</template>
	</div>
</template>

<script>
export default {
	name: 'ThreadAvatar',
	props: {
		participants: Array, 
		participantsInChat: Array, 
		thread: Object, 
		showIndicator: Boolean, 
		size: {
			type: Number,
			default: 60
		}, 
		shadow: {
			type: Boolean,
			default: false
		}, 
		border: {
			type: Boolean,
			default: false
		},
		variant: { 
			type: String,
			default: 'avatar-list'
		}
	},
	computed: {
		numberOfParticipants() {
			return this.participants.length;
		},
	},
	watch: {
		participantsInChat(newValue, oldValue) {
			if(newValue !== oldValue && newValue !== null) {
				if(this.showIndicator) {
					this.bindOnlineStatus();
				}
			}
		}
	},
	methods: {
		bindOnlineStatus() {
			if (this.thread !== null && this.showIndicator) {
				this.participants.map((participant) => {
					const index = this.participantsInChat.findIndex((partInChat) => partInChat.id === participant.id);
					if (index !== -1) {
						// eslint-disable-next-line vue/no-mutating-props
						this.participants[index].online = 'online';
					} else {
						const offlineParticipants = this.participants.filter((part) => part.id !== self.user.id);
						const one_hour = 60 * 60 * 1000; /* ms */

						offlineParticipants.forEach((part) => {
							if((new Date) - new Date(part.last_read) < one_hour) {
								part.online = 'recently';
							} else {
								part.online = 'offline';
							}
						});
					}
				});
			}
		}
	},
	mounted() {
		if(this.participantsInChat && this.showIndicator) {
			this.bindOnlineStatus();
		}
	},
};
</script>

<style lang="scss" scoped>


    .avatar {

		&.fixed-width {
			&.avatar-list  {
				@media (max-width:767px) {
					width:26px !important;
					height: 26px !important;
				}

				width:60px !important;
				height: 60px !important;
			}


			&.avatar-detail {
				width:80px !important;
				height: 80px !important;

				@media (max-width:767px) {
					width:26px !important;
					height: 26px !important;
				}
			}
		}
			
		img {
			@media (max-width:767px) {
				width:26px !important;
				height: 26px !important;
			}


			&.avatar-list {
				width:60px !important;
				height: 60px !important;
				
			}

			&.avatar-detail {
				width:80px !important;
				height: 80px !important;

				@media (max-width:767px) {
					width:26px !important;
					height: 26px !important;
				}
				
			}

			&.shadow {
				@media (min-width:768px) {
					box-shadow: 0px 6px 10px 0px #0000001c;
				}
			}
			&.border {
				@media (min-width:768px) {
					border:4px solid white;
				}
			}
		}
    }
</style>
